var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.994 0a7.992 7.992 0 0 1 7.994 7.994 7.992 7.992 0 0 1-7.994 7.993A7.992 7.992 0 0 1 0 7.994 7.992 7.992 0 0 1 7.994 0Zm0 1.599a6.393 6.393 0 0 0-6.395 6.395 6.393 6.393 0 0 0 6.395 6.395 6.393 6.393 0 0 0 6.395-6.395 6.393 6.393 0 0 0-6.395-6.395Zm0 2.398a3.998 3.998 0 0 1 3.997 3.997 3.998 3.998 0 0 1-3.997 3.997 3.998 3.998 0 0 1-3.997-3.997 3.998 3.998 0 0 1 3.997-3.997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default ForwardRef;